import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { initLenis, destroyLenis, scrollToSection } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ProjectsTeaser } from "@/components/ProjectsTeaser";
import { Concept } from "@/components/Concept";
import { Chi } from "@/components/Chi";
import { Services } from "@/components/Services";
import { Method } from "@/components/Method";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ProjectsPage } from "@/components/ProjectsPage";
import { ProjectDetail } from "@/components/ProjectDetail";
import { LegalPage } from "@/components/LegalPage";
import { PRIVACY_POLICY, COOKIE_POLICY, TERMINI } from "@/data/legal";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      navigate("/", { replace: true, state: {} });
      setTimeout(() => scrollToSection(id), 350);
    }
  }, [location, navigate]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <ProjectsTeaser />
        <Concept />
        <Chi />
        <Services />
        <Method />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

const SubPage = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/progetti" element={<SubPage><ProjectsPage /></SubPage>} />
          <Route path="/progetti/:slug" element={<SubPage><ProjectDetail /></SubPage>} />
          <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY_POLICY} />} />
          <Route path="/cookie-policy" element={<LegalPage doc={COOKIE_POLICY} />} />
          <Route path="/termini" element={<LegalPage doc={TERMINI} />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
